



































import { computed, defineComponent, onMounted } from '@vue/composition-api';
import { v } from '@front-app/components/form/validation/useValidation';
import { required } from '@front-app/components/form/validation/validators';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import { useHighlightsInput } from '@front-app/modules/group/highlights/hooks/useHighlightsInput';
import { ContentSourceObject } from '@front-app/modules/group/highlights/model';
import { decodeContentSource, encodeContentSource } from '@front-app/modules/group/highlights/util/content';
import CategoriesInput from '@front-app/components/inputs/CategoriesInput.vue';
import FormError from '@front-app/components/form/FormError.vue';
import { BUTTON_EDITOR_PROPS } from './buttonEditor';
import BaseButtonEditor from './BaseButtonEditor.vue';

export default defineComponent({
	components: {
		BaseButtonEditor,
		FormSection,
		FormLabel,
		CategoriesInput,
		FormError,
	},
	props: BUTTON_EDITOR_PROPS,
	setup(props, ctx) {
		const useInput = useHighlightsInput(ctx, computed(() => props.value));

		// Content search
		const contentSource = computed(() => decodeContentSource(props.value.meta.contentSource));

		const validation = v({
			categories: {
				value: computed(() => contentSource.value.categories),
				rules: [required()],
			},
		});

		onMounted(() => {
			validation.validate();
		});

		const doContentSourceMeta = (newContentSource: ContentSourceObject) => {
			useInput.doMetaInput({
				groupId: props.group.id,
				contentSource: encodeContentSource({
					categories: newContentSource.categories,
				}),
			});
			validation.validate();
		};
		const removeCategory = (removeCat: string) => {
			doContentSourceMeta({
				categories: contentSource.value.categories.filter((val) => val !== removeCat),
			});
		};
		const addCategory = (newCat: string) => {
			doContentSourceMeta({
				categories: [...contentSource.value.categories, newCat],
			});
		};
		// END Content search

		return {
			validation,
			contentSource,
			doContentSourceMeta,
			removeCategory,
			addCategory,
		};
	},
});
